import clamp from '../../node_modules/lodash-es/clamp.js';

const validateMaxWidth = (number, lower = 0, upper = 350) => {
    if (number > upper)
        // eslint-disable-next-line no-console
        console.warn(`Received max width ${number}, must be less than ${upper}`);
    if (number < lower)
        // eslint-disable-next-line no-console
        console.warn(`Received max width ${number}, must be greater than ${lower}`);
    return clamp(number, lower, upper);
};

export { validateMaxWidth };
